import { useTenant } from '@parcel2go/npm-p2g-app';
import { useCallback } from 'react';
import { Parcel2GoProvider, RoyalMailProvider, SmartSendProvider } from '~/lib/consts/providers';
import { useCompanyName } from './useCompanyName';

const useProviderName = () => {
  const { tenant } = useTenant();
  const companyName = useCompanyName();

  return useCallback(
    (provider: string) => {
      switch (provider) {
        case SmartSendProvider: {
          const profile = tenant?.toUpperCase() || '';

          if (profile.startsWith('DHLPARCEL')) {
            return 'DHL';
          }

          if (profile.startsWith('EVRI')) {
            return 'EVRi';
          }

          if (profile.startsWith('FEDEX')) {
            return 'FedEx';
          }

          if (profile.startsWith('POSTOFFICE')) {
            return 'Post Office';
          }

          if (profile.startsWith('ASENDIA')) {
            return 'Asendia';
          }

          return companyName || 'Parcel2Go';
        }

        case Parcel2GoProvider:
          return 'Parcel2Go';

        case RoyalMailProvider:
          return 'Royal Mail';

        default:
          return provider;
      }
    },
    [companyName, tenant]
  );
};

export default useProviderName;
